export default "__VITE_ASSET__DnSBSb0k__"